export const VARIANTES = [
    {'pt': 'primario', 'en': 'primary', 'nome': 'Primário'}, 
    {'pt': 'secundario', 'en': 'secondary', 'nome': 'Secundário'}, 
    {'pt': 'sucesso', 'en': 'success', 'nome': 'Sucesso'}, 
    {'pt': 'perigo', 'en': 'danger', 'nome': 'Perigo'}, 
    {'pt': 'aviso', 'en': 'warning', 'nome': 'Aviso'}, 
    {'pt': 'info', 'en': 'info', 'nome': 'Informação'}, 
    {'pt': 'claro', 'en': 'light', 'nome': 'Claro'}, 
    {'pt': 'escuro', 'en': 'dark', 'nome': 'Escuro'}, 
];